<template>
    <AccountInput
        class="checkbox-input"
        :errorMessage="errorMessage"
        :name="name"
        @inputErrorDetected="emit('inputErrorDetected', name, errorMessage)"
    >
        <label :for="name" class="checkbox-input__label">
            <input
                class="checkbox-input__input"
                type="checkbox"
                v-model="checkboxValue"
                :id="name"
                @click="checkboxClick"
            />
            <div class="checkbox-input__checkmark"></div>
            <div>
                <div class="checkbox-input__text" v-html="description"></div>
                <div class="checkbox-input__note agree__text" v-show="note" v-html="note"></div>
            </div>
        </label>
    </AccountInput>
</template>
<script setup lang="ts">
import { computed } from "vue";
import AccountInput from "./account-input.vue";

/* eslint-disable @typescript-eslint/naming-convention */
const emit = defineEmits<{
    "update:modelValue": [newValue: boolean];
    inputErrorDetected: [fieldName: string, errorMessage: string];
    click: [];
}>();

const props = defineProps<{
    modelValue: boolean;
    name: string;
    description: string;
    note?: string;
    mandatory: boolean;
    preventDefault?: boolean;
}>();

const errorMessage = defineModel<string>("errorMessage");

const checkboxValue = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        errorMessage.value = null;
        emit("update:modelValue", newValue);
    },
});

const checkIfIsValid = (): boolean => {
    let isValid = true;

    if (props.mandatory && !props.modelValue) {
        errorMessage.value = "Tento souhlas je povinný.";
        isValid = false;
    }

    return isValid;
};

const checkboxClick = (e) => {
    if (props.preventDefault) {
        e.preventDefault();
    }

    emit("click");
};

defineExpose({
    checkIfIsValid,
});
</script>
